import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import d, { forwardRef as ee, useState as te } from "react";
import { c as E } from "./index-DkZ16bcJ.mjs";
import { T as le } from "./text-field-ZOMRKQAY.mjs";
import { A as oe, D as re, a as ie, b as ne, d as se, c as ae } from "./autocomplete-CioiqPo-.mjs";
import { m as P } from "./tss-DN0acMKN.mjs";
import { f as s } from "./index-LyFokDcn.mjs";
import { B as ue } from "./base-icon-v2-DZwX3wnO.mjs";
import { I as de } from "./X10x10-Bso1Otyr.mjs";
import { F as ce } from "./FormControl-C7vROVtA.mjs";
import { a as pe } from "./input-wrapper-qaVcukod.mjs";
import { I as fe } from "./outlined-input-wBBzs904.mjs";
const T = (l) => d.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 8", width: "8", height: "8" }, l),
  d.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    d.createElement(
      "g",
      null,
      d.createElement("path", { d: "M658.696093,583.479908 C659.065694,583.110308 659.10356,582.543285 658.780093,582.219907 C658.456715,581.89644 657.889692,581.934306 657.520092,582.303907 L655,584.823999 L652.479908,582.303907 C652.110308,581.934306 651.543285,581.89644 651.219907,582.219907 C650.89644,582.543285 650.934306,583.110308 651.303907,583.479908 L653.823999,586 L651.303907,588.520092 C650.934306,588.889692 650.89644,589.456715 651.219907,589.780093 C651.543285,590.10356 652.110308,590.065694 652.479908,589.696093 L655,587.176001 L657.520092,589.696093 C657.889692,590.065694 658.456715,590.10356 658.780093,589.780093 C659.10356,589.456715 659.065694,588.889692 658.696093,588.520092 L656.176001,586 L658.696093,583.479908 Z", transform: "translate(-651 -582)" })
    )
  )
);
T.displayName = "X8x8";
function y(l = []) {
  return !!l.length;
}
function F(l = "") {
  if (l)
    return `${l}-autocomplete-multiple-input`;
}
const me = P()((l, u) => {
  const {
    borderRadiuses: r,
    constructs: { icon: t, surface: i },
    spacing: n,
    typography: c
  } = l, { size: a, variant: h } = u;
  let p;
  return h === "single" && (p = a === "small" ? r[400] : r[500]), {
    root: {
      "& .MuiInputBase-root": {
        borderRadius: p,
        flexWrap: "wrap",
        gap: n(0, 1),
        maxHeight: "unset"
        // allow wrapping to multiple lines
      },
      "& .MuiChip-root": {
        backgroundColor: i.neutral.xWeak,
        borderRadius: r[100],
        fontWeight: c.fontWeightMedium,
        gap: n(1),
        padding: n(a === "small" ? "2.5px" : 0.5, 1),
        height: "unset",
        margin: n(a === "small" ? "3px" : 0.5, 0),
        "&.Mui-focusVisible": {
          backgroundColor: i.neutral.weak
        }
      },
      "& .MuiChip-label": {
        ...c.xsmall,
        padding: 0,
        margin: 0
      },
      "& .MuiAutocomplete-input": {
        flex: 1,
        flexBasis: 48,
        padding: a === "small" ? n(0.75, 0) : void 0
      },
      "& .MuiChip-deleteIcon": {
        fill: t.neutral.medium,
        margin: 0
      }
    }
  };
}), ge = P()((l, u) => {
  const { mixins: r, palette: t } = l, { label: i } = u;
  return {
    defaultClearIcon: {
      alignItems: "center",
      display: "flex",
      fill: t.grey[500],
      justifyContent: "center",
      "&:hover": {
        fill: t.grey[700]
      }
    },
    root: {
      "& .MuiChip-root": {
        alignItems: "center",
        borderRadius: 2,
        color: t.grey[1e3],
        display: "flex",
        fontSize: 14,
        lineHeight: "17px",
        margin: 2
      },
      "& .MuiChip-deleteIcon": {
        alignItems: "center",
        display: "flex",
        fill: t.grey[700],
        justifyContent: "center"
      }
    },
    rootOld: {
      "& .MuiFormLabel-root": {
        color: t.grey[800],
        fontSize: 14,
        lineHeight: "19px",
        "&.Mui-disabled": {
          color: t.grey[600]
        }
      },
      "& .MuiInputBase-root": {
        border: `1px solid ${t.grey[400]}`,
        borderRadius: "2px",
        boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.05)",
        display: "flex",
        flexWrap: "wrap",
        marginTop: i ? 26 : 0,
        padding: "0 6px",
        "&.Mui-disabled": {
          border: `1px solid ${t.grey[300]}`
        },
        "&.Mui-focused": {
          border: `1px solid ${t.primary.main}`,
          boxShadow: `0 0 0 2px ${r.alpha(t.primary.lighter, 0.35)}`
        }
      },
      "& .MuiChip-root": {
        alignItems: "center",
        borderRadius: 2,
        color: t.grey[1e3],
        display: "flex",
        fontSize: 14,
        lineHeight: "17px",
        margin: 2
      },
      "& .MuiChip-deleteIcon": {
        alignItems: "center",
        display: "flex",
        fill: t.grey[700],
        justifyContent: "center"
      }
    },
    textFieldInputRoot: {
      alignItems: "flex-start",
      display: "flex",
      flexWrap: "wrap",
      lineHeight: "21px",
      maxHeight: "unset"
    }
  };
});
function he({
  afterLabel: l,
  apiRef: u,
  ariaDescribedby: r,
  biId: t,
  /* @startCleanup encore */
  classes: i = {},
  className: n,
  /* @endCleanup encore */
  closeOnSelect: c = !0,
  disabled: a = !1,
  errorMessage: h,
  filterSelectedOptions: p = !0,
  getTagsLimitLabel: S = se,
  hasClearButton: A = !1,
  hasPopupToggle: w = !1,
  id: R,
  inputRef: C,
  inputProps: L = {},
  inputValue: _,
  isInputTextField: x = !1,
  label: f,
  labelPlacement: H,
  note: O,
  notePlacement: W,
  loading: B = !1,
  loadingText: v = ae,
  onChange: k,
  placeholder: D,
  renderInput: M,
  required: N = !1,
  size: I,
  status: X,
  tagsLimit: U = -1,
  value: m,
  variant: b,
  warningMessage: z,
  ...G
}, V) {
  const { classes: J } = me({ size: I, variant: b }), K = {
    label: f
  }, { classes: g } = ge(K), [Q, Z] = te(() => y(m)), j = m ? y(m) : Q;
  return /* @__PURE__ */ o.jsx(
    oe,
    {
      ...G,
      autoHighlight: !1,
      autoSelect: !1,
      blurOnSelect: !1,
      ChipProps: {
        deleteIcon: s.ifFeature(
          "encore",
          /* @__PURE__ */ o.jsx(
            ue,
            {
              ariaLabel: window.jQuery ? $.__("Clear") : "Clear",
              height: 12,
              name: "circle-x-solid",
              width: 12
            }
          ),
          /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx(T, {}) })
        )
      },
      classes: s.ifFeature("encore", J, i),
      className: s.ifFeature(
        "encore",
        void 0,
        E(
          {
            [g.root]: x,
            [g.rootOld]: !x
          },
          n
        )
      ),
      clearIcon: s.ifFeature(
        "encore",
        void 0,
        /* @__PURE__ */ o.jsx("div", { className: E(g.defaultClearIcon, i.defaultClearIcon), children: /* @__PURE__ */ o.jsx(de, {}) })
      ),
      clearOnBlur: !0,
      clearOnEscape: !1,
      clearText: re,
      closeOnSelect: c,
      closeText: ie,
      "data-fabric-component": "AutocompleteMultiple",
      disabled: a,
      disableListWrap: !1,
      disablePortal: !1,
      filterSelectedOptions: p,
      fullWidth: !0,
      getTagsLimitLabel: S,
      handleHomeEndKeys: !0,
      hasClearButton: A,
      hasPopupToggle: w,
      id: R,
      includeInputInList: !1,
      inputValue: _,
      isAnyInputValueAllowed: !1,
      loading: B,
      loadingText: v,
      multiple: !0,
      onChange: q,
      openOnFocus: !1,
      openText: ne,
      ref: V,
      renderInput: (e) => (e.inputProps["data-bi-id"] = F(t), e.placeholder = D, M ? M(e) : !x && s.ifFeature("encore", !1, !0) ? /* @__PURE__ */ o.jsx(d.Fragment, { children: /* @__PURE__ */ o.jsxs(ce, { fullWidth: !0, ref: e.InputProps.ref, children: [
        f && /* @__PURE__ */ o.jsx(pe, { ...e.InputLabelProps, disabled: e.disabled, shrink: !0, children: f }),
        /* @__PURE__ */ o.jsx(
          fe,
          {
            ...e.InputProps,
            disabled: e.disabled,
            fullWidth: !0,
            id: e.id,
            inputProps: { ...L, ...e.inputProps },
            inputRef: C,
            placeholder: j ? void 0 : e.placeholder
          }
        )
      ] }) }) : /* @__PURE__ */ o.jsx("div", { ref: e.InputProps.ref, children: /* @__PURE__ */ o.jsx(
        le,
        {
          afterLabel: l,
          apiRef: u,
          ariaDescribedby: r,
          biId: F(t),
          disabled: e.disabled,
          errorMessage: h,
          id: e.id,
          InputLabelProps: e.InputLabelProps,
          inputProps: {
            ...e.inputProps,
            ...L
          },
          InputProps: s.ifFeature("encore", e.InputProps, {
            ...e.InputProps,
            className: g.textFieldInputRoot
          }),
          label: f,
          labelPlacement: H,
          note: O,
          notePlacement: W,
          placeholder: j ? void 0 : e.placeholder,
          ref: C,
          required: N,
          size: I,
          status: X,
          variant: b,
          warningMessage: z,
          width: 100
        }
      ) })),
      selectOnFocus: !1,
      size: s.ifFeature("encore", I, "small"),
      tagsLimit: U,
      value: m,
      variant: b
    }
  );
  function q(e, Y) {
    Z(y(e.value)), k(e, Y);
  }
}
const Se = ee(he);
export {
  Se as A
};
//# sourceMappingURL=autocomplete-multiple-BTMdCjN1.mjs.map
